import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

const BUTTON_HEIGHT = designTokens.controlHeight.sm;
const EXPAND_ICON_ROTATION_OPEN = "rotate(-90deg)";
const EXPAND_ICON_ROTATION_CLOSED = "rotate(90deg)";

export const useVaultFolderListStyles = makeStyles({
  card: {
    minWidth: 0,
    overflow: "hidden",
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: projectIqTokens.shadowSm,
  },
  header: {
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[5]} ${designTokens.spacing[3]}`,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: designTokens.spacing[3],
  },
  title: {
    margin: 0,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
  },
  toolbarButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    height: BUTTON_HEIGHT,
    padding: `0 ${designTokens.spacing[3]}`,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
    color: projectIqTokens.ink2,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.semibold,
    cursor: "pointer",
    ":hover": {
      backgroundColor: projectIqTokens.bg,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
  expandAllButton: {
    border: "none",
    backgroundColor: "transparent",
  },
  expandAllIcon: {
    fontSize: designTokens.fontSize.xs,
    transition: `transform ${designTokens.transition.fast}`,
    transform: EXPAND_ICON_ROTATION_CLOSED,
  },
  expandAllIconOpen: {
    transform: EXPAND_ICON_ROTATION_OPEN,
  },
  sortSelect: {
    minWidth: 0,
    height: BUTTON_HEIGHT,
    padding: `0 ${designTokens.spacing[2]}`,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
    color: projectIqTokens.ink,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize["2xs"],
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
  subtitle: {
    margin: `${designTokens.spacing[2]} 0 0`,
    fontSize: designTokens.fontSize["2xs"],
    color: projectIqTokens.muted,
  },
  counts: {
    margin: `${designTokens.spacing[1]} 0 0`,
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.faint,
  },
  list: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
});
